module.exports = __webpack_public_path__ + "img/jqr_xz.cf2787c6.png";